import { useContext } from 'react';
import { GraphEditorContext } from './GraphEditorProvider';
import { useSimpleCycleConnector } from './hooks/useSimpleCycleConnector';
import { useAutoCenter } from './hooks/useAutoCenter';
import { useSelectionExpansion } from './hooks/useSelectionExpansion';

interface GraphEffectsProps {
  enableAutoCenter?: boolean;
}

/**
 * Headless component that activates graph-level side effects:
 * - Cycle membership resolution + SVG decoration visualization
 * - Auto-centering on model changes
 * - Selection expansion to highlight related cells
 *
 * Must be rendered as a child of `<GraphEditorProvider>`.
 */
export function GraphEffects({ enableAutoCenter = true }: GraphEffectsProps) {
  const ctx = useContext(GraphEditorContext);
  const graph = ctx?.graph ?? null;

  useSimpleCycleConnector(graph);
  useAutoCenter(enableAutoCenter ? graph : null);
  useSelectionExpansion(graph);

  return null;
}
